import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Tutor, TutorService } from '../../../../services/tutor.service';

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrl: './general.component.scss',
})
export class GeneralComponent {
  tutor: Tutor | undefined;

  constructor(
    protected tutorService: TutorService,
    protected activeRoute: ActivatedRoute
  ) {
    // The agent shell (`tutors/:tutorId`) holds the id.
    const tutorId =
      this.activeRoute.snapshot.paramMap.get('tutorId') ??
      this.activeRoute.parent?.snapshot.paramMap.get('tutorId');

    this.tutorService.tutors$.subscribe((tutors) => {
      this.tutor = this.tutorService.findTutor(tutorId!);
    });
  }

  ngOnInit() {
    // Logik, die beim Initialisieren der Komponente ausgeführt werden soll
  }
}
